/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  //googleTrackingID: 'UA-174238252-2',
}

//Home Page
const greeting = {
  title: 'Hello 👋.',
  title2: 'Emmanuel',
  logo_name: 'emmy.vera()',
  nickname: 'emmy',
  full_name: 'Emmanuel Oluwaloni',
  subTitle: 'Full Stack Developer, Self Taught. Always learning 🔥.',
  resumeLink:
    'https://drive.google.com/file/d/1h71nMmUazN26Rcgki6nRJ4L_ZF9YNZ1c/view?usp=sharing',
  mail: 'mailto:emmyvera01@gmail.com',
}

const socialMediaLinks = {
  /* Your Social Media Link */
  github: 'https://github.com/emmyvera',
  linkedin: 'https://www.linkedin.com/in/Emmanuel-Oluwaloni',
  gmail: 'emmyvera01@gmail.com',
  twitter: 'https://twitter.com/emmy_dev',
  instagram: 'https://www.instagram.com/emmydev_official/',
}

const skills = {
  data: [
    {
      title: 'Full Stack Development',
      fileName: 'FullStackImg',
      skills: [
        '⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications',
        '⚡ Building responsive website front end using ReactJS',
        '⚡ Developing mobile applications using React Native and Android',
        '⚡ Creating application backend in Node, Express & Django',
        '⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean',
      ],
      softwareSkills: [
        {
          skillName: 'ReactJS',
          fontAwesomeClassname: 'simple-icons:react',
          style: {
            color: '#61DAFB',
          },
        },
        {
          skillName: 'NodeJS',
          fontAwesomeClassname: 'simple-icons:node-dot-js',
          style: {
            color: '#339933',
          },
        },
        {
          skillName: 'MongoDB',
          fontAwesomeClassname: 'simple-icons:mongodb',
          style: {
            color: '#439743',
          },
        },
        {
          skillName: 'MySQL',
          fontAwesomeClassname: 'simple-icons:mysql',
          style: {
            color: '#4479A1',
          },
        },
        {
          skillName: 'Python',
          fontAwesomeClassname: 'simple-icons:python',
          style: {
            color: '#3776AB',
          },
        },
      ],
    },

    {
      title: 'Cloud Infra-Architecture',
      fileName: 'CloudInfraImg',
      skills: [
        '⚡ Experience training model on Google Cloud Platform (GCP)',
        '⚡ Experience working on multiple cloud platforms',
        '⚡ Experience hosting and managing websites',
        //'⚡ Experience with Continuous Integration',
      ],
      softwareSkills: [
        {
          skillName: 'Heroku',
          fontAwesomeClassname: 'simple-icons:heroku',
          style: {
            color: '#6863A6',
          },
        },
        {
          skillName: 'AWS',
          fontAwesomeClassname: 'simple-icons:amazonaws',
          style: {
            color: '#FF9900',
          },
        },
        {
          skillName: 'PostgreSQL',
          fontAwesomeClassname: 'simple-icons:postgresql',
          style: {
            color: '#336791',
          },
        },
      ],
    },
  ],
}

const degrees = {
  degrees: [
    {
      title: 'DataCamp',
      subtitle: 'Professional Courses in DataScience and Machine Learning',
      logo_path: 'datacamp_logo_r.png',
      alt_name: 'DataCamp',
      duration: '2020 - Present',
      descriptions: [
        // "⚡ I'm currently pursuing my bachelors in Information Technology.",
        '⚡ I have studied core subjects like Python Programming, DBMS, SQL, Spreadsheet, etc.',
        '⚡ I have completed various online courses for Data Science , Machine Learning , Image Processing, etc.',
        "⚡ I have implemented several projects based on what I've leart under my Data Science course. ",
      ],
      website_link: 'http://www.datacamp.com/',
    },
    {
      title: 'Federal University, Oye-Ekiti',
      subtitle: 'Bachelor in Electrical and Electronics Engineering',
      logo_path: 'fuoye_logo_r.png',
      alt_name: 'FUOYE',
      duration: '2015 - 2021',
      descriptions: [
        "⚡ I'm done pursuing my bachelors in Electrical and Electronics Engineering.",
        // '⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.',
        // '⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.',
        // "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: 'http://www.fuoye.edu.ng/',
    },
  ],
}

const certifications = {
  certifications: [
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
}

// Experience Page
const experience = {
  title: 'Experience',
  subtitle: 'Work, Internship and Volunteership',
  description:
    'I am a freelancer. I have done projects on my own and I am actively looking for jobs. I love organizing workshops to share my knowledge with others.',
  header_image_path: 'experience.svg',
  sections: [
    {
      title: 'Work Experience',
      experiences: [
        {
          title: 'Full Stack Developer',
          company: 'Nigeria Society of Nigeria (NSE) New Bussa',
          //company_url: 'https://nse.com/',
          logo_path: 'nse_logo.png',
          duration: 'Jan 2020 - Feb 2022',
          location: 'Office',
          description: `
          Work closely with the Client and Team on e-voting webapp.
          We Primarily used SQL, Express EJS & Node (SEEN Stack). 
          50% of my work was doing backend development, 
          30% of my work was designing database schemas, 
          and 20% of my work was on maintain hosting and user traffics on the website.
         `,
          color: '#0071C5',
        },
      ],
    },
    {
      title: 'Volunteerships',
      experiences: [
        {
          title: 'AI+ Lead',
          company: 'DSN',
          company_url: 'https://www.datasciencenigeria.org/',
          logo_path: 'dsn_logo.png',
          duration: 'Nov 2019 - Sept 2021',
          location: 'Hybird',
          description: `Mentorship responsibilities were to help students plan the project, 
            teach, ensure smooth progress and help 
            them out when they are stuck.`,
          color: '#4285F4',
        },

        {
          title: 'GitHub Student Developer',
          company: 'GitHub',
          company_url: 'https://github.com/',
          logo_path: 'github.png',
          duration: 'Nov 2019 - Present',
          location: 'Work from Home',
          description:
            'Contribute to Open Source Community and Open Source Project.',
          color: '#040f26',
        },
        {
          title: 'GDSC Student Volunteer',
          company: 'Google Developer Student Club',
          company_url: 'https://gdg.community.dev/',
          logo_path: 'gdg.png',
          duration: 'Feb 2021 - Present',
          location: 'Work From Home',
          description:
            'Google Developer Student Club FUOYE Student Volunteer and Member.',
          color: '#D83B01',
        },
      ],
    },
  ],
}

// Projects Page
const projectsHeader = {
  title: 'Projects',
  description:
    'My projects make use of a vast variety of latest technology tools. My best experience is to create NodeJS Backend Projects, Python Scripts, and React Project. Below are some of my projects. Note that not all of the mentioned projects are on GitHub yet.',
  avatar_image_path: 'projects_image.svg',
}

// Contact Page
const contactPageData = {
  contactSection: {
    title: 'Contact Me',
    profile_image_path: 'emmydev.png',
    description:
      'You can contact me at the places mentioned below. I will get back to you as fast as I can. ',
  },
  blogSection: {
    title: 'Blogs',
    subtitle:
      "I don't blog frequently but when I do something awesome, I document it so it can be helpful to others. I write on Twitter.",
    link: 'https://twitter.com/emmy_dev',
    avatar_image_path: 'blogs_image.svg',
  },
}

const projects = {
  data: [
    {
      id: '0',
      name: 'E-Voting WebApp',
      url: 'https://github.com/emmyvera/',
      description:
        'This is an election webapp. This will allow users vote for a candidate of their choice',
      languages: [
        {
          name: 'HTML5',
          iconifyClass: 'vscode-icons:file-type-html',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
        {
          name: 'NodeJS',
          iconifyClass: 'logos-nodejs',
        },
      ],
    },
    {
      id: '1',
      name: 'E-Voting WebApp with Face Verification',
      url: 'https://github.com/emmyvera/',
      description:
        'An electronic voting webapp, users need to verify their face (Facial Authentication) before voting for a candidate ',
      languages: [
        {
          name: 'HTML5',
          iconifyClass: 'vscode-icons:file-type-html',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
        {
          name: 'NodeJS',
          iconifyClass: 'logos-nodejs',
        },
        {
          name: 'TypeScript',
          iconifyClass: 'logos-typescript',
        },
      ],
    },
    {
      id: '2',
      name: 'Recipe WebApp',
      url: 'https://github.com/emmyvera/',
      description:
        'A website for sharing various kind of recipes (for learning purposes).',
      languages: [
        {
          name: 'ReactJS',
          iconifyClass: 'logos-react',
        },
        {
          name: 'Python',
          iconifyClass: 'logos-python',
        },
      ],
    },
    {
      id: '3',
      name: 'emmyvera.github.io',
      url: 'https://github.com/emmyvera/emmyvera.github.io',
      description:
        'A Personal Portfolio Website that showcases my work and experience. which is hosted on Github Pages.',
      languages: [
        {
          name: 'HTML5',
          iconifyClass: 'vscode-icons:file-type-html',
        },
        {
          name: 'CSS3',
          iconifyClass: 'vscode-icons:file-type-css',
        },
        {
          name: 'JavaScript',
          iconifyClass: 'logos-javascript',
        },
        {
          name: 'SCSS',
          iconifyClass: 'vscode-icons:file-type-scss2',
        },
      ],
    },
  ],
}

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
}
